module.exports = __webpack_public_path__ + "static/img/create_team.c85c0180.png";